import { EntityPresenterV2Mode, isStaticMode } from './presenterV2EntityMode';

import type { Maybe } from '@nova/core';
import type { YardAssetVisitDetails } from './yardAssetVisitPresenterV2Shared';

export function nestedAssetVisitPresenterDataProps(
  mode: EntityPresenterV2Mode,
  data: { assetVisit?: Maybe<YardAssetVisitDetails> }
) {
  if (isStaticMode(mode)) {
    return {
      staticAssetVisitData: data.assetVisit ?? null
    };
  }

  return {
    placeholderAssetVisitData: data.assetVisit ?? null
  };
}
